import React from 'react';
import styled from 'styled-components';

interface CopyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  showEnjoy: boolean;
}

const StyledCopyButton = styled.button<{showEnjoy: boolean}>`
  font-size:1rem;
  padding: 20px 25px;
  background-color: ${props => props.showEnjoy ? 'white' : 'var(--jargon-secondary)'};
  color: ${props => props.showEnjoy ? 'var(--jargon-secondary)' : 'white'};
  border: 2px solid var(--jargon-secondary);
  cursor: pointer;
  align-self: flex-start;
  min-width: 200px; /* Fixed width to prevent size changes */
  transition: all var(--fade-duration) ease-in-out;
  
  &:hover:not(:disabled):not([data-show-enjoy="true"]) {
    background-color: white;
    color: var(--jargon-secondary);
    border: 2px solid var(--jargon-secondary);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CopyButton: React.FC<CopyButtonProps> = ({ children, showEnjoy, ...rest }) => {
  return (
    <StyledCopyButton showEnjoy={showEnjoy} data-show-enjoy={showEnjoy.toString()} {...rest}>
      {children}
    </StyledCopyButton>
  );
};